var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.tasks)?_c('article',{staticClass:"project-page-task"},[_c('h2',{staticClass:"project-page-title"},[_vm._v("Задача")]),_c('EditorJSArticleComponent',{staticClass:"project-page-task__text",attrs:{"text":_vm.tasks}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }